import styled from 'styled-components'

export const ContainerPlan = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	position: relative;
	margin: 10px 0px;

	strong {
		margin: 0;
	}
`

export const PlanList = styled.ul`
	margin-left: 50px;
	color: #64778f;
	margin-block-start: 1em;
	margin-block-end: 1em;
`

export const Title = styled.p`
	font-style: normal;
	font-weight: 600;
	font-size: 18px;
	line-height: 26px;
	width: fit-content;
	color: #64778f;
	margin: 10px 0;
`

export const Validity = styled.p`
	font-style: normal;
	font-size: 14px;
	line-height: 22px;
	display: flex;
	align-items: center;
	color: #64778f;
	margin: 10px 0 16px 30px;
`

export const AmountContainer = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr auto;
	padding: 10px 0;
	bottom: 0;
	background-color: #f5f7fa;
	margin: 0;
`

export const Amount = styled.p`
	margin-left: 36px;
	font-family: 'Montserrat', sans-serif, Arial;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 15px;
	display: flex;
	align-items: center;
	color: #64778f;
`

export const TotalContainer = styled.div`
	margin: 0;
`

export const Total = styled.p`
	margin-left: 36px;
	font-family: 'Montserrat', sans-serif, Arial;
	font-style: normal;
	font-weight: 700;
	font-size: 16px;
	line-height: 22px;
	display: flex;
	align-items: center;
	color: #5082c2;
`

export const Modifier = styled.p`
	font-family: 'Montserrat', sans-serif, Arial;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 30px;
	display: flex;
	align-items: center;
	text-align: right;
	text-decoration-line: underline;
	color: #5082c2;
	padding-right: 36px;

	cursor: pointer;
`
